export const MESSAGE_TYPE_UPDATE_ONLINE = "message_type_update_online";
export const MESSAGE_TYPE_UPDATE_OFFLINE = "message_type_update_offline";
export const MESSAGE_TYPE_INIT_FINISH = "message_type_init_finish";
export const MESSAGE_TYPE_RE_CONFMON = "message_type_re_confmon";
